import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentBox } from "@msuite/ui/content-box";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { Can } from "@/components/citadel";
import { MailboxHeader } from "./mailbox-header";
import { MailboxMenu } from "./mailbox-menu";
import { MailboxEmails } from "./panels/mailbox-emails";

export function Mailbox() {
	/** Hooks */
	const params = useParams<{ mailboxId: string }>();
	const { t } = useTranslation();
	const mailboxId = params.mailboxId;

	/** Guard */
	if (!mailboxId) return null;

	/** Render */
	return (
		<ContentBox bottomPadding="none">
			{/* The same rule as the settings tab the page is reached from: a mailbox is a credential
			    the organisation holds, and `read Integration` is what the server answers it to. */}
			<Can
				action="read"
				subject="Integration"
				fallback={
					<BlankSlate
						Icon={icon("Mail")}
						label={t("general.no_access")}
					/>
				}
			>
				<MailboxHeader mailboxId={mailboxId} />
				<Tabs
					header={() => <MailboxMenu mailboxId={mailboxId} />}
					groups={[
						{
							name: "general",
							panels: [
								{
									label: t("mailboxes.emails"),
									cyId: "mailbox-emails-tab",
									panel: () => <MailboxEmails mailboxId={mailboxId} />,
									errors: [],
								},
							],
						},
					]}
				/>
			</Can>
		</ContentBox>
	);
}
